<template>
    <div style="color:white">{{data&&data[0]?table_title:undefined}}
    <table border="1">
        <tr v-if="head && head.length>0">
            <th v-for="(item,idx) in head"
                :key = "idx"
            >
            {{item}}
            </th>
        </tr>

        <tr v-for="(row,r_idx) in data"
            :key="r_idx"
            :style="{height:cell_width}"
            :td_n ="Array.isArray(row)?row.length:0"
        >
            <td v-for="(col,c_idx) in row"
                :key="c_idx"
                :style="v_style(col)"

                :title="col_title(col,[r_idx,c_idx,row.length])"
                :colspan="col_span(col)"
                :rowspan="row_span(col)"
                :tips="col_tips(col)"

                @mouseenter="$emit('cellEnter',[col,r_idx,c_idx])"
            >
                <!-- <div v-if="c_idx==0" style="color:inherit;white-space:nowrap">{{data[r_idx][c_idx]}}</div> -->
                <input :style="v_style2(col)"   ref="r_idx + '_' + c_idx" :value="col_value(col)"  :readonly="editable ?  'readonly': false">
                
            </td>

        </tr>

    </table>
  </div>
</template>

<script>


export default ({
    name:'ArrayCanvas',
    props:{
        table_title:String,
        canvas_style:String,
        //cell_size:Number,
        data:Array,
        title:String,
        cell_width:String,
        head:Array,
        config:Object,
    },
    data(){
        return {
            editable:true,
            //data:[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,1,0,1,0], [1,0,0,0,1]],
           // head:[],//['数据1','数据2','数据3','数据4'],
            cell_size:[115,15],
            
            //cell_width:'15px',
            
        }
        
    },
    computed:{
        table_config(){
            let res = {
                title_mode:'index',//index 整体排序位置 index2 坐标  
            };
            Object.assign(res,this.config);
            return res;
        }
    },
    methods: {
        col_title(v,idx){ //位置3 title
            let title = this.arr_get(v,'title:');
            if( title){
                return title;
            }else{
                switch(this.table_config['title_mode']){
                    case 'index':{
                        return idx[2]*idx[0]+idx[1]+1;
                    };
                    case 'index2':{
                        return `(${idx[0]},${idx[1]})`;
                    };
                    case 'row_cnt':{
                        return idx[1]+1;
                    };
                    case 'value':{
                        return Array.isArray(v)?v[0]:v;
                    }
                    default:return '';
                }
            }    
     
        },
        col_span(v){  //位置1
            if(Array.isArray(v)){
                let c_span = v.filter(v=>(typeof(v)=='string') && v.startsWith('c'))?.[0];
                if(c_span)return c_span.replace('c','')
            }   
            return '1';//
        },
        row_span(v){   //位置1
            if(Array.isArray(v)){
                let c_span = v.filter(v=>(typeof(v)=='string') && v.startsWith('r'))?.[0];
                if(c_span)return c_span.replace('r','')
            }   
            return '1';//
        },
        col_tips(v){   //tips 位置1
            if( Array.isArray(v)){
                return v[1]??'';
            }     
            return '';//
        },
        col_value(v){   //位置0 值
            if( Array.isArray(v)){
                return v[0];
            }     
            return v;//
        },
        v_style(v){ //位置2 style
            let style_str = this.arr_get(v,'style:');
            style_str = 'width:' + this.cell_width + ';' + style_str;//把全局默认宽度放前面
            return style_str;
        },
        v_style2(v){ //位置  style 没有宽度
            let style_str = this.arr_get(v,'style:');   
            // style_str = 'width:' + this.cell_width + ';' + style_str;//把全局默认宽度放前面
            return style_str;
        },
        arr_get(arr,pre='c'){
            if(Array.isArray(arr)){
                let c_span = arr.filter(v=>(typeof(v)=='string') && v.startsWith(pre))?.[0];
                if(c_span)return c_span.replace(pre,'')
            };
            return ''
        }
    },
  
})
</script>

<style lang="stylus" scoped>
table
    border-spacing:0;
    border-collapse:collapse;
    border:1px solid rgba(100,100,100,0.5);
    color:yellow;
    max-width:90%;
    overflow:scroll;

    & th
        color:white;
        white-space :nowrap;

input
    appearance:none;
    border:none;
    outline:none;
    padding:0px 1px;
    background-color:transparent;
    color:yellow;
    text-align:center;
    width:100%;

    &[readonly]
        //background-color:gray;
    
    


</style>
